__turbopack_context__.v({
  "button": "tour-completion-modal-module-scss-module__1ctFKG__button",
  "container": "tour-completion-modal-module-scss-module__1ctFKG__container",
  "contentText": "tour-completion-modal-module-scss-module__1ctFKG__contentText",
  "controls": "tour-completion-modal-module-scss-module__1ctFKG__controls",
  "title": "tour-completion-modal-module-scss-module__1ctFKG__title",
});
